module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"one_hour":"1時間","hours":"{value}時間"},"en":{"one_hour":"1 hour","hours":"{value} hours"}}')
  delete Component.options._Ctor
}
